import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NotFoundPage from './components/404';
import HomePage from './components/Home';
import logo from './components/img/doglogo200.png';
import './index.css';

const App = () => (
  <BrowserRouter>
    <div className="page-wrapper">
      <header style={{ textAlign: 'center', paddingTop: '1.5rem' }}>
        <a href="/">
          <img src={logo} className="logo" alt="Clumsy logo" />
        </a>
      </header>

      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <footer className="site-footer">
        &copy; {new Date().getFullYear()} stayclumsy.com
      </footer>
    </div>
  </BrowserRouter>
);

export default App;
